import React from 'react'
import { InlineWidget } from 'react-calendly'

import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import LoadingWidget from '@/components/widgets/LoadingWidget'
import useAppDispatch from '@/hooks/useAppDispatch'
import useAppSelector from '@/hooks/useAppSelector'
import { useIsRoute } from '@/hooks/useIsRoute'
import { EXTERNAL_LINKS } from '@/lib/constants'
import { ROUTES } from '@/lib/routes'
import {
  hideBookMeetingModal,
  selectBookMeetingModalUrl,
} from '@/redux/slices/bookMeetingModal'

const BookMeetingModal: React.FC = () => {
  const bookMeetingModalUrl = useAppSelector(selectBookMeetingModalUrl)
  const dispatch = useAppDispatch()
  const isRoute = useIsRoute()

  if (!bookMeetingModalUrl) {
    return null
  }

  function closeModal() {
    dispatch(hideBookMeetingModal())
  }

  return (
    <Dialog open onHide={closeModal}>
      <DialogContent size="lg">
        <DialogHeader>
          <DialogTitle>Book a slot with our team</DialogTitle>
        </DialogHeader>

        <DialogBody>
          <InlineWidget
            url={EXTERNAL_LINKS.calendly.officeHours}
            styles={{
              width: '100%',
              height: isRoute(ROUTES._help) ? '650px' : '700px',
            }}
            LoadingSpinner={LoadingWidget}
          />
        </DialogBody>
      </DialogContent>
    </Dialog>
  )
}

export default BookMeetingModal
